// extracted by mini-css-extract-plugin
export default {"content-wrapper":"home_content-wrapper__k2Mnq","header":"home_header__y9fE2","content":"home_content__o+02t"};